export enum UpdatePasswordResponseType {
    Success = "Success",
    IncorrectPassword = "Incorrect Password",
    Unknown = "Unknown Error"
}
